export default function Share() {
  return (
    <div
      style={{ backgroundImage: `url(${require("./img/bg.png")})` }}
      className="bg-center bg-cover"
    >
      <div className="container pt-14 mx-auto p-4 lg:p-10 max-w-[1024px]">
        <div className="relative w-full pt-10 pb-44 lg:pb-24">
          <div className="w-full lg:w-3/4 bg-[#FEE7CA] rounded-md p-5 pb-20 lg:pb-10">
            <div className="w-full lg:w-3/4">
              <p className="text-2xl lg:text-4xl font-semibold font-cookie-black uppercase text-[#524433]">
                Share <span className="text-[#daab1d]">Win-Win</span>
                <br className="hidden lg:block" />
                Benefits
              </p>
              <div className="mt-10">
                <div className="flex flex-col lg:flex-row gap-2 justify-start">
                  <img
                    src={require("./img/icon-up.png")}
                    className="inline-block mr-2 h-20 w-20 object-contain"
                  />
                  <div>
                    <p className="text-[#4C2525] font-semibold text-xl">
                      Growth-hacking
                    </p>
                    <p className="text-[#524433]">
                      Higher Brand Awareness,
                      <br className="hidden lg:block" />
                      Faster community growth.{" "}
                    </p>
                  </div>
                </div>
                <div className="flex flex-col lg:flex-row gap-2 justify-start mt-8">
                  <img
                    src={require("./img/icon-up.png")}
                    className="inline-block mr-2 h-20 w-20 object-contain"
                  />
                  <div>
                    <p className="text-[#4C2525] font-semibold text-xl">
                      Cost-saving
                    </p>
                    <p className="text-[#524433]">
                      Sharing contribution without{" "}
                      <br className="hidden lg:block" />
                      paid promotion
                    </p>
                  </div>
                </div>
                <div className="flex flex-col lg:flex-row gap-2 justify-start mt-8">
                  <img
                    src={require("./img/icon-up.png")}
                    className="inline-block mr-2 h-20 w-20 object-contain"
                  />
                  <div>
                    <p className="text-[#4C2525] font-semibold text-xl">
                      Risk-sharing
                    </p>
                    <p className="text-[#524433]">
                      Growing together creates{" "}
                      <br className="hidden lg:block" />
                      equal risk sharing
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="lg:hidden w-full relative mt-8">
              <img
                src={require("./img/mongen-mb.png")}
                className="absolute w-full left-0 top-0 max-w-[400px]"
              />
            </div>
          </div>

          <div className="hidden lg:block w-1/2">
            <img
              src={require("./img/mongen.png")}
              className="absolute w-1/2 right-0 top-0"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
